import React, {useState, useEffect,ref} from 'react';
import SimpleBar from 'simplebar-react';
import Cookies from 'js-cookie';

import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow, IconButton} from '@mui/material';

import NotFound from '../masseges/Not_found';
import SklTable from '../skeletons/Skl_table';
import { useInView } from 'react-intersection-observer'
import EditIcon from '../../assets/edit-new.svg'
import DeleteIcon from '../../assets/delete.svg'
import { useRetryFileMutation, useListInfinityActivityLogs, fetchActivityLogsData } from '../../hooks/useActivityLogs';
import loaderIcon from '../../assets/Loading1.svg'
import Rolling from '../../assets/Rolling.svg'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Collapse from '@mui/material/Collapse';

const ActivityTable = (props) => {

    const [notFound, setNotFound] = useState(false);
    const [loginUserId, setLoginUserId] = useState(Cookies.get('userId') ? Cookies.get('userId') : '')
    const [rowCount, setRowCount] = useState(12);
    const [searchTerm, setSearchTerm] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [sort, setSort] = useState(0);
    const [sortCol, setSortCol] = useState("pending");
    const [docNoCellWidth, setDocNoCellWidth] = useState('5rem')
    const [openRowIds, setOpenRowIds] = useState([]);
    const toggleRow = (id) => {
    setOpenRowIds((prev) =>
        prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
    };
      const { ref, inView } = useInView()
    const {data: docs, fetchNextPage, hasNextPage, isFetchingNextPage, refetch, isLoading, isError, error} = useListInfinityActivityLogs({rowCount,dateFrom,dateTo,searchTerm});
       const [loader, setLoader] = useState(true);
    const timestampToHumanDate = (timestamp) => {
        const date = new Date(timestamp * 1000); // Convert to milliseconds
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };
    

   

    //handling data preview in table *****
   
       useEffect(() => {
            
           console.log('docs********', docs,'docs.page', docs ? docs.pages : 'no', 'docs.pages at', docs ? docs.pages.at(0) : 'no at')
   
           //set data not found
   
           if(docs && docs?.pages?.at(0)){   
   
               if(docs?.pages?.at(0) && docs?.pages?.at(0)?.logs?.length < 1){
                   setNotFound(true)
                   console.log('not found if', docs?.pages && docs?.pages?.at(0)?.logs?.length);
               }
               else{
                   setNotFound(false)
                   //console.log('not found else');
               }
   
               //set max row count
   
               //docs && docs.document.length > maxRowCount ? setMaxRowCount(docs.document.length -1) : setMaxRowCount(maxRowCount)
   
           }
         
       }, [docs]); 
   
       //set loaders
   
       useEffect(()=>{
   
           if (isLoading) {
               console.log('isLoading', isLoading);
               setLoader(true);
           }
           else{
               setLoader(false);
               console.log('isLoading else', isLoading);
           }
   
       },[docs, isLoading])

       useEffect(() => {
               console.log('nextPage', inView)
               if (inView) {
                   console.log('nextPage inView')
                 fetchNextPage();
               }
           }, [fetchNextPage, inView]);

        useEffect(()=>{
                   //console.log('searchTerm child', props.searchTerm)
            const delayDebounce = setTimeout(() => {
                console.log('textsearch',props.searchTerm)
                setSearchTerm(props.searchTerm)
                setDateFrom(props.dateFrom)
                setDateTo(props.dateTo)
                       //setLoader(true);
            }, 300);
                 
            console.log('textsearch before ret',props.searchTerm)
            return () => clearTimeout(delayDebounce);
           
        },[props.searchTerm,props.dateFrom,props.dateTo])
       
           // Manually trigger fetchData *****
       
           const handleFetchData = async () => {
               refetch()
               console.log('refetch')
           };


    return(
        <>
            <div className={`mb-5 border-solid border border-borderGrayDark  rounded-xl doc-review overflow-hidden relative min-height-docView-uncheck`}>
                {/* <SimpleBar className={selectedDelete.length > 0 ? 'min-height-docView' : 'min-height-docView-uncheck'} scrollableNodeProps={{ ref: scrollableNodeRef }} > */}
                <div>
                {/* {loader || (props.uploading && (docs?.pages?.at(0)?.documents.length < 1)) ? (   */}

                {isLoading  ? (

                    <SklTable 
                        tableRow={15}
                        tableCol={3}
                        hasCheckBox={false}
                        hasActions={0}
                    />
                    
                    ): notFound && !props.uploading ? (  
                    
                        <NotFound msgText={'No Activity logs found!'}/>

                    ):(
                        
                        <TableContainer className="height-docView-uncheck max-h-[600px] overflow-y-auto overflow-x-hidden">
                        <Table stickyHeader aria-label="Review documents" className="doc-review-table w-full table-fixed">
                            <TableHead className="tableHead">
                                <TableRow>
                                <TableCell className="w-[18rem]">Date and time</TableCell>
                                <TableCell className="w-[14rem]">User</TableCell>
                                <TableCell className="min-w-[12rem]">Activity</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {docs?.pages?.map((page, pageIndex) => (
                                <React.Fragment key={`page-${pageIndex}`}>
                                    {page?.logs?.map((doc, index) => (
                                    <React.Fragment key={`log-${doc.id}`}>
                                        {/* Main row */}
                                        <TableRow onClick={() => toggleRow(doc.id)} className="cursor-pointer hover:bg-gray-100 transition">
                                        <TableCell className="min-h-[11rem] truncate" sx={{ lineHeight: '3' }}>
                                            {doc.created_at}
                                        </TableCell>

                                        <TableCell className="truncate min-h-[11rem]" sx={{ lineHeight: '3' }}>
                                            {doc.user_name || 'N/A'}
                                        </TableCell>

                                        <TableCell className="min-h-[11rem] px-2 min-w-[12rem]" sx={{ lineHeight: '3' }}>
                                            <div className="flex items-center justify-between gap-2">
                                            <span className="truncate w-full">{doc.action_details || 'N/A'}</span>
                                            <IconButton
                                                size="small"
                                                className="flex-shrink-0"
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent row click from also firing
                                                    toggleRow(doc.id);
                                                  }}
                                            >
                                                {openRowIds.includes(doc.id) ? (
                                                <KeyboardArrowUpIcon fontSize="small" />
                                                ) : (
                                                <KeyboardArrowDownIcon fontSize="small" />
                                                )}
                                            </IconButton>
                                            </div>
                                        </TableCell>
                                        </TableRow>

                                        {/* Collapsible row */}
                                        {doc.action_type !== 'delete' && (
                                <TableRow>
                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
                                    <Collapse in={openRowIds.includes(doc.id)} timeout="auto" unmountOnExit>
                                        <div className="p-4 bg-gray-50 text-sm rounded-b-md border-t border-gray-200">
                                        {(() => {
                                            let parsedChanges = [];

                                            try {
                                            const obj = JSON.parse(doc.changes);
                                            parsedChanges = Object.entries(obj).flatMap(([field, value]) => {
                                                const isNestedObject =
                                                typeof value?.old === "object" && value.old !== null &&
                                                typeof value?.new === "object" && value.new !== null;

                                                if (isNestedObject) {
                                                const allKeys = Array.from(new Set([
                                                    ...Object.keys(value.old || {}),
                                                    ...Object.keys(value.new || {})
                                                ]));

                                                return allKeys.map((subKey) => ({
                                                    field: `${field} → ${subKey}`,
                                                    from: value.old?.[subKey],
                                                    to: value.new?.[subKey]
                                                }));
                                                }

                                                return [{
                                                field,
                                                from: value.old,
                                                to: value.new
                                                }];
                                            });
                                            } catch (err) {
                                            console.error("Failed to parse changes:", err);
                                            }

                                            return parsedChanges.length > 0 ? (
                                            <div className="space-y-3">
                                                {parsedChanges.map((change, i) => (
                                                <div
                                                    key={i}
                                                    className="border border-gray-200 rounded-md bg-white"
                                                    style={{ padding: '4px 10px' }}
                                                >
                                                    <p className="font-semibold text-sonicSilver text-[11px] leading-snug p-0 m-0">{change.field}:</p>
                                                    {change.from !== undefined && doc.action_type === 'update' ? (
                                                    <div className="grid grid-cols-2 gap-3 text-xs mt-1">
                                                        <div>
                                                        <p className="font-medium text-gray-500 text-[11px] p-0 m-0 leading-tight text-sonicSilver">From</p>
                                                        <p className="text-gray-700 text-[10px] p-0 m-0 leading-snug">{String(change.from)}</p>
                                                        </div>
                                                        <div>
                                                        <p className="font-medium text-gray-500 text-[11px] p-0 m-0 leading-tight text-sonicSilver">To</p>
                                                        <p className="text-green-600 text-[10px] p-0 m-0 leading-snug">{String(change.to)}</p>
                                                        </div>
                                                    </div>
                                                    ) : (
                                                    <p className="text-green-600 text-[10px] p-0 m-0 leading-snug">{String(change.to)}</p>
                                                    )}
                                                </div>
                                                ))}
                                            </div>
                                            ) : (
                                            <p className="text-gray-500 italic text-xs p-0 m-0">No detailed changes available.</p>
                                            );
                                        })()}
                                        </div>
                                    </Collapse>
                                    </TableCell>
                                </TableRow>
                                )}




                                    </React.Fragment>
                                    ))}
                                </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>

                      
                        <div ref={ref} className="h-[0.25rem] w-full text-center">
                          {isFetchingNextPage ? (
                            <img className="max-w-[2rem] min-h-[2rem] py-4" src={loaderIcon} alt="loading logo" />
                          ) : hasNextPage ? (
                            ''
                          ) : (
                            ''
                          )}
                        </div>
                      </TableContainer>
                      
                )}
                </div>
                {/* </SimpleBar> */}
                {props.uploading ? (
                    !props.uploadCompeted ? (
                        <div className='absolute text-primary text-base bottom-0 right-0 flex bg-white border border-solid border-primary px-8 py-4 rounded-xl m-5 font-semibold'><img src={Rolling} alt='loading' className='w-5 mr-3'/>Uploaded {props.uploadFiles} of {props.submitFiles} items...</div>
                        ):(
                            <div className='absolute text-primary text-base bottom-0 right-0 flex bg-white border border-solid border-primary px-8 py-4 rounded-xl m-5 font-semibold'><img src={Rolling} alt='loading' className='w-5 mr-3'/>{props.uploadFiles} of {props.submitFiles} uploads completed. Please wait...</div>
                        )
                    ):''
                }
            </div>
        </>    
    );
}

export default ActivityTable;